import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useGetMeQuery } from "../store/api";
import { logout, setAuthUser } from "../store/slices/authSlice";
import { Loader } from "./icons";

export default function ProtectedRoute({ children }) {
  const dispatch = useDispatch();
  const { data, isLoading, isError, error } = useGetMeQuery();

  useEffect(() => {
    if (data?.data) {
      dispatch(setAuthUser(data.data));
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (isError) {
      dispatch(logout());
    }
  }, [isError, dispatch]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (isError || !data?.data) {
    return <Navigate to="/account/login" replace state={{ from: error }} />;
  }

  return children;
}
